/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TriggerChallengeDistributionBody
 */
export interface TriggerChallengeDistributionBody {
    /**
     * 
     * @type {boolean}
     * @memberof TriggerChallengeDistributionBody
     */
    dryRun?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TriggerChallengeDistributionBody
     */
    simulateNow?: number;
}

/**
 * Check if a given object implements the TriggerChallengeDistributionBody interface.
 */
export function instanceOfTriggerChallengeDistributionBody(value: object): value is TriggerChallengeDistributionBody {
    return true;
}

export function TriggerChallengeDistributionBodyFromJSON(json: any): TriggerChallengeDistributionBody {
    return TriggerChallengeDistributionBodyFromJSONTyped(json, false);
}

export function TriggerChallengeDistributionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerChallengeDistributionBody {
    if (json == null) {
        return json;
    }
    return {
        
        'dryRun': json['dryRun'] == null ? undefined : json['dryRun'],
        'simulateNow': json['simulateNow'] == null ? undefined : json['simulateNow'],
    };
}

export function TriggerChallengeDistributionBodyToJSON(json: any): TriggerChallengeDistributionBody {
    return TriggerChallengeDistributionBodyToJSONTyped(json, false);
}

export function TriggerChallengeDistributionBodyToJSONTyped(value?: TriggerChallengeDistributionBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dryRun': value['dryRun'],
        'simulateNow': value['simulateNow'],
    };
}

